import API from 'services/API/index';

export default function getLk20NotificationStatus() {
  return API.request({
    method: 'GET',
    url: '/notification/hasLk20Notifications',
  });
}
